import { getSidebarSchema } from "./sidebarSchema";
import { api } from "../../common/utils/api";

export const initSidebarForm = () => {
  // Target the specific form in the sidebar
  const container = document.getElementById("contact-form-container");
  const form = container?.querySelector<HTMLFormElement>(".pa-form");

  if (!form || !container) return;

  const submitBtn = form.querySelector<HTMLButtonElement>(".pa-form__submit");
  const originalBtnText = submitBtn?.innerText || "GÖNDER";

  // Create the alert box inside the form dynamically to match the sidebar style
  const errorAlert = document.createElement("div");
  errorAlert.style.display = "none";
  errorAlert.style.padding = "15px";
  errorAlert.style.marginBottom = "15px";
  errorAlert.style.backgroundColor = "rgba(220, 38, 38, 0.1)"; // Dark red tint
  errorAlert.style.borderLeft = "4px solid #dc2626";
  errorAlert.style.color = "#fca5a5"; // Light red text
  errorAlert.style.fontSize = "13px";
  errorAlert.style.borderRadius = "4px";
  form.prepend(errorAlert);

  const clearErrors = () => {
    form
      .querySelectorAll(".cf-field__input, input[type='checkbox']")
      .forEach((el) => {
        el.classList.remove("has-error");
        // Reset checkbox inline styling just in case
        if ((el as HTMLInputElement).type === "checkbox") {
          (el as HTMLElement).style.borderColor = "#3b4b5c";
        }
      });
    form
      .querySelectorAll(".cf-field__error")
      .forEach((el) => (el.textContent = ""));
    errorAlert.style.display = "none";
    errorAlert.innerHTML = "";
  };

  const setFieldError = (fieldName: string, message: string) => {
    const input = form.querySelector(`[name="${fieldName}"]`);

    // Handle Checkbox Error Visually
    if (input && input.getAttribute("type") === "checkbox") {
      (input as HTMLElement).style.borderColor = "#dc2626"; // Red border
      errorAlert.style.display = "block";
      errorAlert.innerHTML += `<div style="margin-bottom: 5px;">• ${message}</div>`;
      return;
    }

    // Handle Standard Input Errors
    const errorDiv = input
      ?.closest(".pa-form__field")
      ?.querySelector(".cf-field__error");
    if (input && errorDiv) {
      input.classList.add("has-error");
      // Add red border using inline styles for high specificity in the dark sidebar
      (input as HTMLElement).style.outline = "2px solid #dc2626";
      errorDiv.textContent = message;
      // Style the error text below the input
      (errorDiv as HTMLElement).style.color = "#fca5a5";
      (errorDiv as HTMLElement).style.fontSize = "12px";
      (errorDiv as HTMLElement).style.marginTop = "5px";
    }
  };

  // Custom Success State designed specifically for the dark sidebar
  const renderSuccessState = () => `
    <div style="text-align: center; padding: 40px 20px; color: #ffffff;">
      <div style="color: #10b981; margin-bottom: 20px;">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 60px; height: 60px; margin: 0 auto;">
            <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      </div>
      <h3 style="font-size: 22px; font-weight: 700; margin-bottom: 10px; font-family: var(--font-family-secondary);">
        Talebiniz Alındı!
      </h3>
      <p style="font-size: 14px; opacity: 0.8; line-height: 1.6;">
        Projemize gösterdiğiniz ilgi için teşekkür ederiz. Müşteri temsilcilerimiz en kısa sürede sizinle iletişime geçecektir.
      </p>
    </div>
  `;

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    clearErrors();

    const formData = new FormData(form);
    const rawData = Object.fromEntries(formData.entries());

    const result = getSidebarSchema().safeParse(rawData);

    // --- VALIDATION FAILED ---
    if (!result.success) {
      Object.entries(result.error.flatten().fieldErrors).forEach(
        ([field, msgs]) => {
          if (msgs) setFieldError(field, msgs[0]);
        },
      );

      // Clear the red outline when the user starts typing again
      form.querySelectorAll("input, textarea").forEach((input) => {
        input.addEventListener(
          "input",
          (e) => {
            (e.target as HTMLElement).style.outline = "";
            (e.target as HTMLElement).style.borderColor = ""; // Fixes checkbox
          },
          { once: true },
        );
      });
      return;
    }

    // --- ON FLIGHT STATE ---
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerText = "GÖNDERİLİYOR...";
      submitBtn.style.opacity = "0.7";
      submitBtn.style.cursor = "not-allowed";
    }

    const inputs = form.querySelectorAll("input, textarea");
    inputs.forEach((input) => ((input as HTMLInputElement).disabled = true));

    try {
      await api.post("/forms/contact", result.data);

      // --- SUCCESS STATE ---
      container.innerHTML = renderSuccessState();

      // --- GA4 EVENT TRACKING ---
      if (typeof (window as any).gtag === "function") {
        (window as any).gtag("event", "generate_lead", {
          form_type: "Project Application Form",
          project_name: result.data.project_name || "",
        });
      }
    } catch (err: any) {
      // --- ERROR STATE ---
      inputs.forEach((input) => ((input as HTMLInputElement).disabled = false));

      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerText = originalBtnText;
        submitBtn.style.opacity = "1";
        submitBtn.style.cursor = "pointer";
      }

      errorAlert.style.display = "block";
      errorAlert.innerHTML = `<div>• ${err.message || "Bir hata oluştu. Lütfen tekrar deneyiniz."}</div>`;
    }
  });
};
